import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { ArFeatureBaseModel } from './arFeatureBase.model';
import { ArFeatureDataState } from './arFeatureDataState.enum';

export interface ArFeatureBaseOutboundService<T extends ArFeatureBaseModel> {
    /**
     * This method updates the state of the data
     *
     * @param state
     */
    updateState(state: ArFeatureDataState): void;

    /**
     * This method takes an annual report instance object and attaches it's newly created content to it
     * then it will return it back.
     *
     * Use this method if you want to save modified data
     *
     * @param original annual report instance from where data is taken
     */
    getModifiedData(original: IAnnualReport): IAnnualReport;
}
